export { default } from './StuiCopyToClipboard'
